import StyledSelect from "./Select";

export default StyledSelect;
